import { api } from 'app/store';
import { makeUseRequest } from 'hooks';
import { IResidentialSignUpContent } from 'types';

export const useResidentialContent = makeUseRequest<IResidentialSignUpContent>(
  api.residential.fetch.bind(api.residential)
);
